import React, { useCallback, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { apiUrl } from "../../dataProvider";

const getOptionValue = item =>
  item.sku_code || item.id || item.attribute_type_id || item.option_category_id || item.name;

const normalizeOptions = data => {
  if (!Array.isArray(data)) return [];

  if (data.length === 0) return [];

  if (typeof data[0] === "string" || typeof data[0] === "number") {
    return data.map(item => ({
      id: item,
      name: String(item),
      sku_code: item,
    }));
  }

  return data;
};

const TagValueSelect = ({ resource, value, onChange, disabled = false }) => {
  const [list, setList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const getLists = params =>
    axios.get(`${apiUrl}/${resource}`, { params }).then(({ data }) => data.data);

  const getSearchOptions = search =>
    getLists({ "filter[name]": search })
      .then(normalizeOptions)
      .catch(() => []);

  const setOptionList = useCallback(
    async params => {
      if (!resource) return;

      try {
        setLoading(true);
        const response = await getLists(params);
        setList(normalizeOptions(response));
      } catch (error) {
        setList([]);
      } finally {
        setLoading(false);
      }
    },
    [resource]
  );

  useEffect(() => {
    setList([]);
    setSearchValue("");

    if (resource) {
      setOptionList({
        "page[number]": 1,
        "page[size]": 1000,
      });
    }
  }, [resource, setOptionList]);

  const selectedOption =
    list.find(
      item =>
        item.sku_code === value ||
        item.name === value ||
        String(item.id) === String(value) ||
        String(item.attribute_type_id) === String(value) ||
        String(item.option_category_id) === String(value)
    ) || null;

  const handleChange = selected => {
    if (searchValue) {
      setOptionList({ "filter[name]": searchValue });
    }
    onChange(selected ? selected.name || selected.sku_code || getOptionValue(selected) : "");
  };

  if (!resource) {
    return (
      <AsyncSelect
        isDisabled
        placeholder="No options available for this key"
        styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
      />
    );
  }

  return (
    <div>
      <AsyncSelect
        isClearable
        cacheOptions
        isLoading={loading}
        isDisabled={disabled}
        placeholder="Select value"
        styles={{
          menu: provided => ({ ...provided, zIndex: 9999 }),
        }}
        defaultOptions={list}
        getOptionLabel={option => option.name}
        getOptionValue={getOptionValue}
        value={selectedOption}
        loadOptions={getSearchOptions}
        onChange={handleChange}
        onInputChange={setSearchValue}
      />
    </div>
  );
};

export default TagValueSelect;
